import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {GetMarketingCodeResponse} from '../types';

const getMarketingCodeResponseMock: GetMarketingCodeResponse = {
  id: '6db9934d-7fb5-4ad8-b34f-ef5d72ed8c45',
  warehouseId: '855bd140-6054-4d4b-beeb-2adbf5ee89b4',
  name: 'Spring sale 15% markup',
  salesBasePriceMarkup: 15,
  externalCode: 'SPRING2024',
};

const postMarketingCodeResponseInterceptor = (server: SetupServerApi) =>
  server.use(http.post('*/warehouse/v1/marketing-code', () => HttpResponse.json()));

const patchMarketingCodeResponseInterceptor = (server: SetupServerApi) =>
  server.use(http.patch('*/warehouse/v1/marketing-code/*', () => HttpResponse.json()));

export const metadaWarehouseMarketingCodeApiMock = {
  getMarketingCodeResponseMock,
  postMarketingCodeResponseInterceptor,
  patchMarketingCodeResponseInterceptor,
};
